export class TableContextRewrite {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "state",
            "baseName": "state",
            "type": "TableContextRewriteState",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextRewrite.attributeTypeMap;
    }
    constructor() {
    }
}
